import { Reducer } from 'redux';
import { DialogsState, DialogsTypes } from './types';

const INITIAL_STATE: DialogsState = {
  dialog: {
    open: false,
    isDialogPrint: false,
    content: null,
    propsDialog: null,
    disableBackdropClick: false,
  },
  secondDialog: {
    open: false,
    content: null,
    propsDialog: null,
    disableBackdropClick: false,
    wasCalled: false,
  },
  isLoading: true,
};

const reducer: Reducer<DialogsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DialogsTypes.SET_OPEN:
      return { ...state, dialog: { ...action.payload } };
    case DialogsTypes.SET_CLOSE:
      return { ...state, dialog: { ...action.payload } };

    case DialogsTypes.SET_SECOND_OPEN:
      return { ...state, secondDialog: { ...action.payload } };
    case DialogsTypes.SET_SECOND_CLOSE:
      return { ...state, secondDialog: { ...action.payload } };

    // IS_LOADING
    case DialogsTypes.IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading };

    default:
      return state;
  }
};

export default reducer;
